import { httpClient, unwrap } from './httpClient';

export async function getServiceUsageTimeseries({ serviceCallback, rangeMinute, userIds }) {
  const response = await httpClient.get('/service-usage/timeseries', {
    params: {
      service_callback: serviceCallback || undefined,
      range_minute: rangeMinute,
      user_ids: userIds?.length ? userIds.join(',') : undefined,
    },
  });
  return unwrap(response);
}

const serviceUsageService = {
  getServiceUsageTimeseries,
};

export default serviceUsageService;
